import CONF from 'config/conf.singleton';
import USER_ROLE from 'constants/role';
import { AUTH_API } from 'middleware/api';
import getAny from 'utils/accessors/getAny.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';

import {
  EDIT_STYLIST_FAILURE,
  EDIT_STYLIST_REQUEST,
  EDIT_STYLIST_SUCCESS,
  setStylistSaved,
} from 'onboarding/stylists/actions';

const ATAG = 'editStylist';
const L = logger(ATAG);

const determinePermissionLevel = (stylist) =>
  stylist.email ? fromAnyToString(stylist.permission_level).trim().toLowerCase() || null : USER_ROLE.noAccess;

const putStylist = (options) => {
  const stylistId = getAny(null, 'stylist.id', options);
  if (!stylistId) {
    L.warn('putStylist()', 'Invalid stylistId:', stylistId);
    return { EDIT_STYLIST_FAILURE };
  }

  const salonId = getAny(null, 'salonId', options);
  const stylist = getAny({}, 'stylist', options) || {};
  const hasColumn = getAny(false, 'has_column', stylist);

  const data = {
    ...stylist,
    permission_level: determinePermissionLevel(stylist),
    role_id: hasColumn ? getAny(null, 'role.id', stylist) : undefined,
    role: hasColumn ? stylist.role : undefined,
    user_id: getAny(null, 'user_id', stylist) || null,
    salon_id: salonId,
  };

  return {
    ATAG,
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/${salonId}/stylist/${stylistId}/`,
      authenticated: true,
      types: [EDIT_STYLIST_REQUEST, EDIT_STYLIST_SUCCESS, EDIT_STYLIST_FAILURE],
      config: {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      },
      params: { stylistId, salonId },
    },
  };
};

const editStylist = L.wrap('()', (options) => (dispatch) => {
  const stylistId = getAny(null, 'stylist.id', options);

  if (!stylistId) {
    return Promise.reject(L.warn('()', `Invalid stylistId: ${stylistId}`));
  }

  const dispatchPromise = dispatch(putStylist(options));
  dispatchPromise.then(({ type }) => type === EDIT_STYLIST_SUCCESS && dispatch(setStylistSaved()));
  return dispatchPromise;
});

// noinspection JSUnusedGlobalSymbols
export default editStylist;
